module.exports = __webpack_public_path__ + "e6f05a1c4e3fff2832baef1fe4cd8053.svg";